import React from "react";

export default function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#000000",
        color: "#ffffff",
        padding: "22px 0",
        textAlign: "center",
        fontFamily: "'Orbitron', sans-serif",
        letterSpacing: "0.08em",
        marginTop: "auto",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;500;700&display=swap');
      `}</style>

      <p style={{ margin: 0, fontSize: "0.85rem" }}>
        © {new Date().getFullYear()} Junebase Robotics. All rights reserved.
      </p>

      <p
        style={{
          marginTop: "6px",
          fontSize: "0.7rem",
          color: "#7d8084",
          letterSpacing: "0.12em",
        }}
      >
        Designed and built with AI-assisted workflows
      </p>
    </footer>
  );
}